export const linkProvider = {
  links:{
    googleAppleSuccessfulSubscription: "https://readingtrainer.onelink.me/8csA/lov3cnfc",
    googleAppleStartPage: "https://readingtrainer.onelink.me/8csA/ea99655a",
    googleAppleDashboard: "https://readingtrainer.onelink.me/8csA/d8f67ca0",
    googleApplePostExercise: "https://readingtrainer.onelink.me/8csA/94600f93",
    googleApplePopUp: "https://readingtrainer.onelink.me/8csA/90679d5a",

    QRcode: "https://readingtrainer.onelink.me/8csA/gv4u0k8y",

    amazonDashboard: "https://rt-com.onelink.me/DQmo/3eb8b36",
    amazonModal: "https://rt-com.onelink.me/DQmo/c8bf145b",
    amazonPostExercise: "https://rt-com.onelink.me/DQmo/1f895c99",

    googleAppStore: 'https://play.google.com/store/apps/details?id=com.heku.readingtrainer',
    amazonAppStore: 'https://www.amazon.com/HeKu-IT-GmbH-Reading-Trainer/dp/B00B4XKEW6',
    appleAppStore: 'https://apps.apple.com/app/id416814366'
  }
}